<script setup lang="ts">
    import { inject } from 'vue';
    import { useRoute } from 'vue-router';
    import FinanceDecaissementsForm from './@forms/FinanceDecaissementsForm.vue';
    import { calculatePercentage } from '@/utils';

    
    const route = useRoute();
    const BACKEND_URL = inject('BACKEND_URL');
    const startup_infos: any = route.meta.startup_infos;
    const collectivite: any = startup_infos.collectivite;
</script>
<template>
    <section class="container-full-1 bg-grey-50">
        <div class="page-space-40"></div>

        <h4 class="s7 font-semibold px-3 pb-5">Finance / Décaissement <span class="text-sm text-grey-500"></span></h4>
        <div class="s13 flex-right gap-3 mt--2 mb-5 px-5">
            <span class="btn shadow-200 white2">Wallet</span>
            <span class="btn shadow-200 white2">Gérer les prélèvements</span>
            <span class="btn shadow-200 light2 border-none">Prélèvements / Décaissements</span>
        </div>


        <!--Collectivité info - Component-->
        <div class="s20 widget flex align-items-center px-1 py-5">
            <div class="s2_mobile h-100p px-7">
                <div class="rounded-100 overflow-hidden item active"><!--active-->
                    <img src="/assets/logos/logo1.svg" width="100%" />
                </div>
            </div>
            <div class="s4_mobile h-100p px-2">
                <h4 class="mb-2">{{ collectivite.nom }}</h4>
                <h3>C788PMKJ</h3>
            </div>
            <div class="s3_mobile h-100p px-2">
                <h4 class="font-normal mb-5">{{ collectivite.users_count }} / 50000 Membres</h4>
                <span class="tag-state warning stroke">En cours</span>
                <span class="tag-state notif stroke">Actif</span>
            </div>
            <div class="s4_mobile h-100p px-3">
                <h4 class="font-normal">
                    Date de souscription <br class="mb-2"/>
                    <b class="text-2xl">{{ collectivite.created_at_formatted }}</b>
                </h4>
            </div>
            <div class="s7_mobile h-100p px-5">
                <!--Barre de progression - Component-->
                <div class="h-60 rounded-100 position-relative" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                    <div class="widget-floating py-0 text-xl flex-right">Membres {{ calculatePercentage(collectivite.users_count, 50000, 2) }}%</div>
                    <div class="h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-green" style="width: 90%;" :style="{'width': calculatePercentage(collectivite.users_count, 50000, 2) + '%'}">
                        {{ collectivite.users_count }} / 50000
                    </div>
                </div>
                <!--End Barre de progression-->
            </div>
        </div>
        <!--End Collectivité info-->
        <div class="clear-both h-20"></div>
        
        <!--Prélèvements / Décaissements-->
        <FinanceDecaissementsForm :startup-infos="startup_infos" />

        <div class="clear-both h-50"></div>

    </section>
</template>